import React from 'react';
import { useTranslation } from 'react-i18next';

import { CoreLink } from '@uncinc/react-drupal-core';
import type { MenuItemLinkElementProps } from '@uncinc/react-drupal-core/dist/Components/RecursiveMenu/types';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import { RecursiveMenu } from '../../../components';

import './style.scss';

const MenuLi: React.FC<MenuItemLinkElementProps> = ({
  data,
  children,
  ...props
}) => (
  <CoreLink ariaLabel={props.title} href={props.url} className="RecursiveMenu__title haslink">
    <Icon name={props.title.toLowerCase()} />
  </CoreLink>
);

const SocialMenu = () => {
  const { t } = useTranslation();

  return (
    <div className="SocialMenu">
      <RecursiveMenu
        menuId="social"
        MenuItemLinkElement={MenuLi}
        navProps={{ 'aria-label': t('recursive_menu.social.aria_label') }}
      />
    </div>
  );
};

export default SocialMenu;
